let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("oBiIQ")).then(() => parcelRequire('eeZv8'));